import BaseApi from "./BaseApi";
import { serverURL, submitRedirectURL } from "../constants/constants";
//import { requestData3Pax } from './mockRequestData';
import qs from "qs";

export const getRooms = async reqObj => {
  const reqStr = qs.stringify(reqObj, { allowDots: true, encode: false });
  const result = await BaseApi.get(`/reservationProcess/roomResults?${reqStr}`);
  return result;
};

export const redirectToregistrationPage = (selectedSessions, hotelId) => {
  //const selectedSessionsAsJson = JSON.stringify(selectedSessions);
  let query = `hotelId=${hotelId}`;
  for (let i = 0; i < selectedSessions.length; i++) {
    const encodedSession = encodeURIComponent(selectedSessions[i]);
    query += `&sessions[${i}]=${encodedSession}`;
  }
  window.location = `${serverURL}${submitRedirectURL}?${query}`;
};

export const getCurrencies = async () => {
  //const reqStr = qs.stringify(reqObj, { allowDots: true, encode: false });
  const result = await BaseApi.get(`http://www.boi.org.il/currency.xml`, true);
  return result;
};



// WEBPACK FOOTER //
// ./src/api/rooms.js